import { ErrorCodes } from '../../../ErrorHandler/apiErrorHandler';

/** The banner text for a failure, shared by the components' useEffect and refreshData's catch. */
export const deriveErrorMessage = (error: unknown, component: string): string => {
  if (component === 'lse') {
    return 'Unable to get LSE details. Please refresh the page or try again later';
  }
  if (component === 'cloudwatchGraphs') {
    return 'Unable to get Cloudwatch Metrics. Please refresh or try again later';
  }

  const message = error instanceof Error ? error.message : String(error ?? '');
  // A truncated or non-JSON body reaches the client as a parse error, not as a status. The proxy timing
  // out mid-response is the usual cause, so it is reported as the gateway timeout it actually is.
  if (message.includes('unexpected character') || message.includes('Unexpected token')) {
    return (
      'Unable to get domain details. Failed with ' +
      ErrorCodes.BAD_GATEWAY +
      ' Timeout. Please reload the page or try again later'
    );
  }
  return 'Unable to get domain details. Failed with ' + message;
};
